import { dateTime, dateTimeParse } from "@gravity-ui/date-utils";
export function getLocalDateTime(input) {
    return new Date(input);
}
/**
 * Форматирование дат без привязки к локальному часовому поясу
 * @param dateInput - Дата, которую нужно отформатировать
 * @param formats - Строка или массив строк форматов (для указания времени и даты)
 * @returns Отформатированная строка или массив строк
 */
export const formatDate = (dateInput, formats) => {
    const dateTimeInput = dateTime({ input: dateInput });
    return formatDateTime(dateTimeInput, formats);
};
export const formatDateTime = (date, formats) => {
    if (typeof formats === "string")
        return date.format(formats);
    return formats.map((format) => date.format(format));
};
/**
 * Функция обработки диапазона дат в фильтрах
 * Парсит диапазон дат и возвращает объект с полями `dateFrom` и `dateTo` в формате ISO.
 * @param start - начальная дата диапазона
 * @param end - конечная дата диапазона
 */
export const parseDateRange = (start, end) => {
    const format = "YYYY-MM-DDTHH:mm:ssZ";
    // для корректной работы с сохраненными фильтрами
    const parsedStart = start ? dateTimeParse(start) : undefined;
    const parsedEnd = end ? dateTimeParse(end) : undefined;
    return {
        dateFrom: parsedStart
            ? formatDateTime(parsedStart, format)
            : undefined,
        dateTo: parsedEnd
            ? formatDateTime(parsedEnd, format)
            : undefined,
    };
};
export function parseDateTime(value) {
    const parsed = dateTimeParse(value);
    return parsed?.isValid ? parsed : null;
}
/**
 * Форматирование дат с секундами
 * @param dateInput - Дата, которую нужно отформатировать
 * @returns Объект с отдельными строками для даты и времени
 */
export const formatDateTimeWithSeconds = (dateInput) => {
    const dateTimeInput = dateTime({ input: dateInput });
    return {
        date: dateTimeInput.format("DD.MM.YYYY"),
        time: dateTimeInput.format("HH:mm:ss"),
    };
};
